import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, input, output } from '@angular/core';
import { MatTooltipModule, TooltipPosition } from '@angular/material/tooltip';
import { LabelsProviderPipe } from '../../pipes/labels-provider/labels-provider.pipe';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [CommonModule, LabelsProviderPipe, MatTooltipModule],
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent {
  isEnabled = input(true);
  buttonTextLabelPath = input<string>('');
  buttonIconPath = input<string | undefined>(undefined);
  tooltipPosition = input<TooltipPosition>('left');
  disabledTooltipText = input<string | undefined>(undefined);
  isUppercase = input(false);
  buttonClicked = output<MouseEvent>();

  public handleClick(event: MouseEvent): void {
    this.buttonClicked.emit(event);
  }
}
